import * as form from '../form';

export const financialAssetSeized = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        SeizureType: form.radio(xitem.SeizureType),
        SeizureTypeExplain: form.textarea(xitem.SeizureTypeExplain),
        Why: form.textarea(xitem.Why),
        When: form.datecontrol(xitem.When),
        WhenEstimated: form.checkbox(xitem.WhenEstimated),
        AmountOwed: form.number(xitem.AmountOwed),
        AmountOwedEstimated: form.checkbox(xitem.AmountOwedEstimated),
        Current: form.branch(xitem.Current),
        WhenResolved: form.datecontrol(xitem.WhenResolved),
        WhenResolvedEstimated: form.checkbox(xitem.WhenResolvedEstimated),
        ActionsTaken: form.textarea(xitem.ActionsTaken),
        ActionsTakenNone: form.notapplicable(xitem.ActionsTakenNone),
        ActionsTakenReason: form.textarea(xitem.ActionsTakenReason),
        EntityType: form.radio(xitem.EntityType),
        EntityTypeExplain: form.textarea(xitem.EntityTypeExplain),
        EntityName: form.text(xitem.EntityName),
        PrivateName: form.name(xitem.PrivateName),
        PropertyLocation: form.location(xitem.PropertyLocation),
        FirstPastDue: form.datecontrol(xitem.FirstPastDue),
        NumberMissed: form.text(xitem.NumberMissed),
        CourtName: form.text(xitem.CourtName),
        CourtNameNotApplicable: form.notapplicable(xitem.CourtNameNotApplicable),
        CourtLocation: form.location(xitem.CourtLocation),
        OrderNum: form.text(xitem.OrderNum),
        OrderNumIdk: form.notapplicable(xitem.OrderNumIdk),
      },
    };
  });
  return {
    HasAssetSeized: form.branch(data.HasAssetSeized),
    List: form.collection(items, (data.List || {}).branch),
  };
};
